import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableTHead } from '@celebration/design-system/dist/lib/table-thead';

export default createComponent({
    react: React,
    elementClass: ClbTableTHead,
    tagName: ClbTableTHead.tagName,
    events: ClbTableTHead.events,
});
